import { TagSemanticoDTO } from '@framework/api-client';
import { useMemo } from 'react';
import { parseSemanticTagSearchable } from './parseSemanticTagSearchable';
import { formatSemanticTagSearchable } from './semanticTagSearchableTransform';

/**
 * Funzione che ritorna le trasformazioni tra la query e il searchable
 * nel componente di advance search, inclusa la gestione dei tag semantici
 */
export function useSemanticTagSearchableTransform<
  T extends { campiSemantici?: string },
>(semanticTags: TagSemanticoDTO[] | null | undefined) {
  const transform = useMemo(
    () => ({
      format: (values: Record<string, any>) => {
        return formatSemanticTagSearchable(values, semanticTags);
      },
      parse: (values: T) => {
        return parseSemanticTagSearchable(values, semanticTags);
      },
    }),
    [semanticTags],
  );

  return transform;
}
